import { getV2 } from 'api/request'

export const API_LEAD_SCHEME = "/core/lead/scheme"

// v2 registers the bare collection path WITH a trailing slash.
export const getLeadSchemeList = (offset = 0, size = 100) => getV2(`${API_LEAD_SCHEME}/`, { urlParams: { offset, size } })
